"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MainFooter = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireDefault(require("react"));
var _contextProps = require("../../../../propTypes/contextProps");
var _PetSureCopyright = require("../PetSureCopyright");
var _SocialLinks = require("../SocialLinks");
var _PetSureFooterDisclosureStatement = require("../PetSureFooterDisclosureStatement");
var _CustomFooterContent = require("../CustomFooterContent");
require("./mainFooter.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const MainFooter = _ref => {
  let {
    brandKey,
    customContent,
    customCssClass,
    socialLinks,
    copyright,
    customDisclosure,
    footerSections
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("footer", {
    className: "mainFooter ".concat(customCssClass || ''),
    id: "mainFooter"
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "mainFooterContent"
  }, footerSections && /*#__PURE__*/_react.default.createElement(_CustomFooterContent.CustomFooterContent, {
    footerSections: footerSections
  }), customContent, /*#__PURE__*/_react.default.createElement("section", null, /*#__PURE__*/_react.default.createElement(_SocialLinks.SocialLinks, {
    socialLinks: socialLinks
  }), copyright, customDisclosure && /*#__PURE__*/_react.default.createElement(_PetSureFooterDisclosureStatement.PetSureFooterDisclosureStatement, _extends({
    brandKey: brandKey
  }, customDisclosure)))));
};
exports.MainFooter = MainFooter;
MainFooter.propTypes = _contextProps.FooterProps;
var _default = exports.default = MainFooter;